<!-- Icon Picker Trigger -->
<button
  #trigger
  type="button"
  class="zag-icon-picker__trigger"
  [attr.aria-haspopup]="'dialog'"
  [attr.aria-expanded]="isOpen()"
  [attr.aria-disabled]="disabled()"
  [disabled]="disabled()"
  (click)="toggle()"
  (focus)="onTriggerFocus()"
  (blur)="onTriggerBlur()"
>
  <span class="zag-icon-picker__value" [class.zag-icon-picker__value--placeholder]="!displayIcon()">
    @if (displayIcon()) {
    <span [zagIcon]="displayIcon()!.name" class="zag-icon-picker__selected-icon"></span>
    } {{ displayText() }}
  </span>
  @if (showClearButton()) {
  <button type="button" class="zag-icon-picker__clear" aria-label="Clear selection" (click)="clearSelection($event)">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>
  }
  <span class="zag-icon-picker__arrow" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" [class.zag-icon-picker__arrow--rotated]="isOpen()">
      <path d="M7 10l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </span>
</button>

<!-- Icon Picker Panel (rendered in CDK overlay) -->
<ng-template #panelTemplate>
  <dialog open class="zag-icon-picker__panel" aria-label="Select an icon">
    <!-- Search input -->
    <div class="zag-icon-picker__search">
      <span zagIcon="search" class="zag-icon-picker__search-icon"></span>
      <input
        type="text"
        class="zag-icon-picker__search-input"
        placeholder="Search icons..."
        [value]="searchQuery()"
        (input)="onSearchInput($event)"
        autocomplete="off"
      />
    </div>

    <!-- Icons grid grouped by category -->
    <div class="zag-icon-picker__categories">
      @if (iconsService.isLoading()) {
      <div class="zag-icon-picker__loading">
        <span class="zag-icon-picker__spinner"></span>
        Loading icons...
      </div>
      } @else if (filteredGroups().length === 0) {
      <div class="zag-icon-picker__empty">No icons found</div>
      } @else { @for (group of filteredGroups(); track group.category) {
      <div class="zag-icon-picker__category">
        <div class="zag-icon-picker__category-label">{{ group.label }}</div>
        <div class="zag-icon-picker__grid">
          @for (icon of group.icons; track icon.id) {
          <button
            type="button"
            class="zag-icon-picker__icon-button"
            [class.zag-icon-picker__icon-button--selected]="isSelected(icon)"
            [attr.aria-label]="icon.label"
            [attr.aria-pressed]="isSelected(icon)"
            [title]="icon.label"
            (click)="selectIcon(icon)"
          >
            <span [zagIcon]="icon.name" class="zag-icon-picker__icon"></span>
          </button>
          }
        </div>
      </div>
      } }
    </div>
  </dialog>
</ng-template>
